//#region Imports
import type { IUserSubscriptionStatusRecord, DeepReadonlyT } from "@anydo/interfaces";
import { escapedUrl, SETTINGS_API_ORIGIN_URL } from "@anydo/core";
import { createAuthHeaders } from "./createAuthHeaders";
//#endregion

//#region Types
type ParamsT = {
  authToken: string;
  subscriptionStatus?: DeepReadonlyT<IUserSubscriptionStatusRecord> | null;
};
//#endregion

export async function postPremiumStripeInvoices({ authToken, subscriptionStatus }: ParamsT): Promise<void> {
  const subId = subscriptionStatus?.subscriptionData?.stripe_sub.id;

  if (!subId) {
    throw new Error("postPremiumStripeInvoices(): User has no Stripe subscription");
  }

  const url = escapedUrl`${SETTINGS_API_ORIGIN_URL}/me/invoice/stripe/${subId}`;

  const response = await fetch(url, {
    method: "POST",
    headers: createAuthHeaders(authToken),
  });

  if (!response.ok) {
    throw new Error(`postPremiumStripeInvoices(): status ${response.statusText} - ${response.statusText}`);
  }
}
